//core
import React from 'react';
import { useTranslation } from "react-i18next";
import arePropsEqual from "react-fast-compare";
import { Chip } from "@mui/material";

//theme
import { Theme } from "@mui/material/styles/createTheme";
import { useTheme } from "@mui/styles";


interface IChipViewProps {
  value: string;
  prefix?: string;
}

const ChipView: React.FC<IChipViewProps> = ({ value, prefix = '' }): React.ReactElement => {
  const theme: Theme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      {!!value ? (
        <Chip
          size="small"
          label={!!prefix ? `${t(`${prefix}${value}`)}` : value}
          color="secondary"
          variant="outlined"
        />
      ) : '—'}
    </>
  );
};

export default ChipView;
